<section
  class="goal-activities-section"
  [style.padding-bottom.rem]="areActivitiesExpanded() ? 2 : 0">
  <div class="activities-table" [class.activities-table-expanded]="areActivitiesExpanded()">
    <table>
      <thead>
        <tr>
          <th>historique</th>
          <th>nom prénom</th>
          <th>temps</th>
          <th>distance</th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading()) {
          @for (skeletonRow of skeletonRows(); track skeletonRow) {
            <tr class="activity-skeleton-row">
              <td>
                <kin-skeleton shape="rect" unit="rem" [height]="1" [width]="7" />
              </td>
              <td>
                <div class="participant-name">
                  <kin-skeleton shape="circle" unit="rem" [height]="1" [width]="1" />
                  <kin-skeleton shape="rect" unit="rem" [height]="1" [width]="10" />
                </div>
              </td>
              <td>
                <kin-skeleton shape="rect" unit="rem" [height]="1" [width]="5" />
              </td>
              <td>
                <kin-skeleton shape="rect" unit="rem" [height]="1" [width]="4" />
              </td>
            </tr>
          }
        } @else {
          @for (activityRow of activityRows(); track activityRow.id) {
            @let activity = activityRow.activity;
            <tr>
              <td>{{ activity.start_date | date: 'short' }}</td>
              <td>
                <div class="participant-name">
                  <kin-icon
                    class="gender-icon"
                    [name]="getGenderIconName(activity)"
                    [relativeSize]="true" />
                  @if (!activity.firstname && !activity.lastname) {
                    <span>Anonymous</span>
                  } @else {
                    <span>{{ activity.firstname }} {{ activity.lastname }}</span>
                  }
                </div>
              </td>
              <td>{{ activity.duration }}</td>
              <td>{{ activity.distance }} m</td>
            </tr>
          }
        }
      </tbody>
    </table>

    @if (areActivitiesExpanded()) {
      <div class="activities-pagination">
        <app-pagination
          class="goal-pagination"
          [appearance]="paginationAppearance"
          [meta]="paginationMeta()"
          (pageChange)="activitiesPageChange.emit($event)" />
      </div>
    }
  </div>

  <div class="activities-footer">
    <a class="powered-link" target="_blank" href="https://kinomap.com/">Powered by Kinomap</a>
    @if (shouldShowToggle()) {
      <button class="activities-toggle" (click)="toggleExpansion.emit()" type="button">
        {{ areActivitiesExpanded() ? 'masquer tout' : 'afficher tout' }}
      </button>
    }
  </div>
</section>
